/**
 * Which Gateway generation this build talks to.
 *
 * WHY THIS IS NOT DERIVED FROM NET_MODE
 * `NET_MODE` says which network (MAIN / FORK / TEST). It cannot answer this,
 * because MAIN is V1 today and will be V2 after activation — the same network,
 * a different contract generation.
 *
 * WHY IT MATTERS
 * V2 widened the User, BusinessValue and Order structs. Reading a V1 gateway
 * through the V2 ABI does not degrade gracefully, it throws:
 *
 *   getUser on V1 via V2 ABI -> "Position `671` is out of bounds"
 *   oldGateway() on V1       -> reverted, the function does not exist
 *
 * which empties the whole dashboard, not just the DNM figure. The reverse is
 * equally broken. So the ABI has to be chosen, not guessed.
 *
 * Defaults to v1 — the generation actually live on mainnet — so that merging
 * V2 support cannot repoint a production build on its own. Set
 * `NEXT_PUBLIC_GATEWAY_VERSION=v2` in the same change that repoints
 * `NEXT_PUBLIC_GATEWAY` and `NEXT_PUBLIC_MARKET_NFT` at the V2 contracts.
 */

export type GatewayVersion = "v1" | "v2";

export const GATEWAY_VERSION: GatewayVersion =
  (process.env.NEXT_PUBLIC_GATEWAY_VERSION ?? "").trim().toLowerCase() === "v2"
    ? "v2"
    : "v1";

export const IS_GATEWAY_V2 = GATEWAY_VERSION === "v2";
